import layout from './EmbeddedListView.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedListViewViewModel from '@/ViewModels/Controls/EmbeddedListViewViewModel';
import EventHelper from '@/Utility/EventHelper';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class EmbeddedListView extends Control {
    protected jQueryControl: JQuery;

    public constructor(protected readonly viewModel: EmbeddedListViewViewModel, private element?: JQuery) {
        super(viewModel as any, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        this.applyBindings(this.jQueryControl, {
            controlName: 'embeddedlistview',

            controlIdent: this.identifier,

            locator: this.viewModel.locator
        });

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback() {
        // Durch die Slider-Panels muss einmal "resize" gefeuert werden, sonst bleibt die View wei�
        // Au�erdem ein Timeout, falls in einem TabControl, wo animiert wird
        this.defineSubscription(this.viewModel.isDisplayed,
            (isDisplayed) => {
                if (isDisplayed) {
                    window.setTimeout(() => { $(window).trigger('resize'); }, 120);
                }
            });

        if (this.viewModel.inheritPersistenceContext)
            EventHelper.bindDropNotPossible(this.jQueryControl);
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setControl('EmbeddedListView', EmbeddedListView, 'RADPresentation.HTMLClient.DefaultViewExtensions');